import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { fuseAnimations } from '../../../../../@fuse/animations';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRippleModule } from '@angular/material/core';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
    FormControl,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    Validators
} from '@angular/forms';
import { NgxSpinnerComponent, NgxSpinnerService } from 'ngx-spinner';
import { catchError, finalize, Observable, of, Subject, takeUntil } from 'rxjs';
import { FuseConfirmationService } from '../../../../../@fuse/services/confirmation';
import { RestFactoryService } from '../../../../core/services/rest-factory.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { CityTypes } from "../../../auth/auth.types";
import { FuseAlertComponent } from "../../../../../@fuse/components/alert";
import { FuseCardComponent } from "../../../../../@fuse/components/card";
import { NoSpacesNoSpecialDirective } from "../../../../core/directives/no-spaces-no-special.directive";
import { MessageFactoryService } from "../../../../core/services/message-factory.service";

@Component({
    selector: "skin-cities-management-list",
    templateUrl: "./data-mapping-list.component.html",
    styleUrls: ["./data-mapping-list.component.scss"],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: fuseAnimations,
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatRippleModule,
        MatSortModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatToolbarModule,
        MatDialogModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        NgxSpinnerComponent,
        MatAutocompleteModule,
        FuseAlertComponent,
        FuseCardComponent,
        NoSpacesNoSpecialDirective,
    ]
})
export class DataMappingListComponent implements OnInit, OnDestroy {

    isMobile: boolean;
    loadingMessage: string = null;

    selectedElement: any = null;
    selectedStoryTypeForm: UntypedFormGroup;

    displayAddSkin: boolean = false;
    alert: any;
    newDestinationForm: UntypedFormGroup;


    inputInternalSearchControl: UntypedFormControl = new UntypedFormControl("");
    originalMapList: any[] = [];
    filteredMapList: any[] = [];
    selectedMapElement: any = null;

    parentArray: CityTypes[] = [];
    parentControl = new FormControl(null);
    filteredParents: Observable<any[]>;

    parentCheckerRequired: boolean = true;

    typingTimeout: any;
    destination: CityTypes = null;

    inputSearchControl: UntypedFormControl = new UntypedFormControl("");
    tableElementsArray: any[] = [];

    // Pagination
    pageIndex: number = 0;
    pageSize: number = 10;
    isLoading: boolean = false;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    // API URL
    private API_GET_TABLE_ELEMENTS = "/admin/skin/list";
    private API_CREATE_NEW_SKIN = "/admin/skin/create";
    private API_GET_MAPPING_LIST = "/admin/skin/listdestinations";
    private API_GET_DESTINATIONS_SEARCH = "/admin/destination/search";
    private API_ADD_TO_MAP = "/admin/skin/adddestination";
    private API_DELETE_FROM_MAP = "/admin/skin/removedestination";

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _formBuilder: UntypedFormBuilder,
        private _fuseConfirmationService: FuseConfirmationService,
        private _restFactoryService: RestFactoryService,
        private spinner: NgxSpinnerService,
        private breakpointObserver: BreakpointObserver,
        private messageFactory: MessageFactoryService,
        private _snackBar: MatSnackBar
    ) {
    }

    ngOnInit(): void {
        this.breakpointObserver.observe([
            Breakpoints.HandsetPortrait,
            Breakpoints.HandsetLandscape
        ]).subscribe(result => {
            this.isMobile = result.matches;
        });
        this.searchElements(null);
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    onKeyup(): void {
        clearTimeout(this.typingTimeout);
        this.typingTimeout = setTimeout(() => {
            this.searchElements(null);
        }, 500);
    }

    searchElements(searcher: string): void {
        let data = {
            "ds_keyword": this.inputSearchControl.getRawValue(),
            "id_destinationtype": "89c9b80f-8ff5-44b9-bc7a-a6cb1d15e0fe"
        };
        let dynaAPI = this.API_GET_TABLE_ELEMENTS;

        const payload = this._restFactoryService.createPayloadPaginator(searcher, this._paginator, data, 20);
        this.tableElementsArray = [];
        this.loadingMessage = "Loading...";
        this.spinner.show().then();

        this._unsubscribeAll.next(null);
        this._restFactoryService.httpPostService(dynaAPI, payload)
            .pipe(
                takeUntil(this._unsubscribeAll),
                finalize(() => {
                    this._changeDetectorRef.detectChanges();
                }),
                catchError((err) => {
                    this.spinner.hide().then();
                    this.loadingMessage = "No results found!";
                    return err;
                })
            )
            .subscribe(
                (response) => {
                    this.spinner.hide().then(
                        () => {
                            this.tableElementsArray = response.ar_skins;
                            if (this.tableElementsArray.length === 0) {
                                this.loadingMessage = "No results found";
                            }
                            this._paginator.length = response.vi_TotalRows;
                            this.isLoading = true;
                            this.spinner.hide().then();
                            this._changeDetectorRef.markForCheck();
                        }
                    );
                });
    }

    toggleDetails(soID: string, eleKey: string): void {
        if (this.selectedElement && this.selectedElement[eleKey] === soID) {
            this.closeDetails(eleKey);
            return;
        }

        if (this.selectedElement && this.selectedElement[eleKey] === null) {
            this.closeDetails(eleKey);
            return;
        }

        this.selectedElement = this.tableElementsArray.find(item => item[eleKey] === soID) || null;

        if (this.selectedElement) {
            this.selectedStoryTypeForm = this._formBuilder.group({
                eleKey: [{ value: this.selectedElement[eleKey], disabled: true }],
                ds_name: [{ value: this.selectedElement.ds_airline, disabled: true }],
            });
        }
        this.getElementMapList(eleKey);
        this._changeDetectorRef.detectChanges();
    }

    getElementMapList(keyEle: string) {
        const payload = new FormData();
        payload.append(keyEle, this.selectedElement[keyEle]);
        this._restFactoryService.httpPostService(this.API_GET_MAPPING_LIST, payload)
            .pipe(
                takeUntil(this._unsubscribeAll),
                finalize(() => {
                    this._changeDetectorRef.detectChanges();
                }),
                catchError((err) => {
                    return err;
                })
            )
            .subscribe(
                (response) => {
                    this.originalMapList = response.ar_results || [];
                    this.filteredMapList = [...this.originalMapList];
                });
    }

    closeDetails(eleKey: string): void {
        if (this.selectedElement[eleKey] === null || (this.selectedStoryTypeForm.touched && this.selectedStoryTypeForm.dirty)) {
            const message = this._fuseConfirmationService.open({
                title: "Warning!",
                message: "The element is not saved, and changes will be lost on toggle!",
                actions: {
                    confirm: { show: true },
                    cancel: { show: true }
                },
                dismissible: false
            });
            message.afterClosed().subscribe(
                (value) => {
                    if (value === "confirmed") {
                        if (this.selectedElement[eleKey] === null) {
                            this.tableElementsArray.shift();
                        }
                        this.selectedElement = null;
                        this.selectedStoryTypeForm = null;
                        this.parentControl.reset();
                        this._changeDetectorRef.markForCheck();
                    }
                }
            );
        } else {
            this.selectedElement = null;
            this.selectedStoryTypeForm = null;
            this.parentControl.reset();
            this._changeDetectorRef.markForCheck();
        }
    }

    addToMapList(): void {
        const data = {
            "id_airline": this.selectedElement.id_airline,
            "id_destination": this.selectedMapElement.id_destination
        }
        const payload = this._restFactoryService.createPayloadPaginator(null, null, data);
        this._unsubscribeAll.next(null);
        this._restFactoryService.httpPostService(this.API_ADD_TO_MAP, payload)
            .pipe(
                takeUntil(this._unsubscribeAll),
                finalize(() => {
                    this._changeDetectorRef.detectChanges();
                }),
                catchError((err) => {
                    return err;
                })
            )
            .subscribe(
                (response) => {
                    // Update list pushing DEV visibility fields
                    this.originalMapList.push({
                        ds_destinationchild: this.selectedMapElement.ds_name,
                        id_destinationdependency: response.data?.id_destinationdependency,
                        id_destination: this.selectedMapElement.id_destination,
                        ds_en_state: this.selectedMapElement.ds_en_state
                    });
                    this.searchMapList();
                    this.parentControl.reset();
                    this.selectedMapElement = null;
                    this._changeDetectorRef.detectChanges();
                });
    }

    onBlur(): void {
        setTimeout(() => {
            const value = this.parentControl.value;
            if (typeof value === 'string' && !this.parentArray.find(city => city.ds_name === value)) {
                this.parentControl.reset();
                this.parentControl.setErrors({ 'invalid': true });
                this.parentControl.markAsTouched();
                this.selectedMapElement = null;
            }
            if (!value) {
                this.parentControl.reset();
                this.parentControl.setErrors({ 'invalid': true });
                this.parentControl.markAsTouched();
                this.selectedMapElement = null;
            }
        }, 500);
    }

    displayFn(display: any): string {
        return display ? display.ds_name : '';
    }

    optionSelected(event: any) {
        this.selectedMapElement = event.option.value;
    }

    onKeyupAutoSearch(event: any): void {
        clearTimeout(this.typingTimeout);
        this.typingTimeout = setTimeout(() => {
            if (event.target.value.length > 2) {
                this.searchParent(event.target.value);
            }
        }, 500);
    }

    searchParent(searchTerm: string = null): void {
        const data = {
            "ds_name": searchTerm ? searchTerm : this.parentControl?.value,
            "bl_deleted": false,
            "id_airline": this.selectedElement?.id_airline ?? ''
        }
        const payload = this._restFactoryService.createPayloadPaginator(null, null, data);
        this._unsubscribeAll.next(null);
        this._restFactoryService.httpPostService(this.API_GET_DESTINATIONS_SEARCH, payload, "ar_results")
            .pipe(
                takeUntil(this._unsubscribeAll),
                catchError((err) => {
                    return err;
                })
            )
            .subscribe(
                (response) => {
                    this.filteredParents = of(response);
                    if (response.length === 0) {
                        this.parentControl.setErrors({ 'invalid': true });
                        this.parentControl.markAsTouched();
                    }
                    this._changeDetectorRef.detectChanges();
                });
    }

    searchMapList(): void {
        const searchTerm = this.inputInternalSearchControl.getRawValue()?.toLowerCase();
        if (searchTerm) {
            this.filteredMapList = this.originalMapList.filter((item) => {
                return (item.ds_destinationchild && item.ds_destinationchild.toLowerCase().includes(searchTerm)) ||
                    (item.id_destination && item.id_destination.toLowerCase().includes(searchTerm)) ||
                    (item.ds_en_state && item.ds_en_state.toLowerCase().includes(searchTerm));
            });
        } else {
            this.filteredMapList = [...this.originalMapList];
        }
        this._changeDetectorRef.detectChanges();
    }

    deleteTag(id: string, eleKey: string): void {
        const payload = new FormData();
        payload.append(eleKey, id);
        this._restFactoryService.httpPostService(this.API_DELETE_FROM_MAP, payload)
            .pipe(
                takeUntil(this._unsubscribeAll),
                finalize(() => {
                    this._changeDetectorRef.detectChanges();
                }),
                catchError((err) => {
                    return err;
                })
            )
            .subscribe(
                (response) => {
                    this.originalMapList = this.originalMapList.filter((item) => item[eleKey] !== id);
                    this.searchMapList();
                    this._changeDetectorRef.detectChanges();
                });
    }

    createForm(): void {
        this.newDestinationForm = this._formBuilder.group({
            ds_name: [null, Validators.required],
            ds_url: [null, Validators.required]
        });
    }

    displayFnSkin(display: any): string {
        return display ? display.ds_airline : '';
    }

    keyUpAddSkin(event: any): void {
        clearTimeout(this.typingTimeout);
        this.typingTimeout = setTimeout(() => {
            if (event.target.value.length > 2) {
                this.searchSkin(event.target.value);
            }
        }, 500);
    }

    searchSkin(searchTerm: string = null): void {
        const data = {
            "ds_keyword": searchTerm ? searchTerm : this.parentControl?.value,
        }
        const payload = this._restFactoryService.createPayloadPaginator(null, null, data);
        this._unsubscribeAll.next(null);
        this._restFactoryService.httpPostService(this.API_GET_TABLE_ELEMENTS, payload, "ar_skins")
            .pipe(
                takeUntil(this._unsubscribeAll),
                finalize(() => {
                    this._changeDetectorRef.detectChanges();
                }),
                catchError((err) => {
                    return err;
                })
            )
            .subscribe(
                (response) => {
                    this.filteredParents = of(response);
                    if (response.length === 0) {
                        this.parentControl.setErrors({ 'invalid': true });
                        this.parentControl.markAsTouched();
                    }
                    this._changeDetectorRef.detectChanges();
                });
    }

    createDestination() {
        const payload = new FormData();
        payload.append("ds_baseName", this.newDestinationForm.getRawValue().ds_name);
        payload.append("ds_endpoint", this.newDestinationForm.getRawValue().ds_url);
        payload.append("id_sourceAirline", this.selectedMapElement.id_airline);

        this._fuseConfirmationService.open({
            title: "Warning!",
            message: "This item will add new whole skin, and can take some minutes!",
            actions: {
                confirm: { show: true },
                cancel: { show: true }
            },
            dismissible: true
        }).afterClosed().subscribe((result) => {
            if (result === "confirmed") {
                this.spinner.show("managementSpinner").then();
                this._unsubscribeAll.next(null);
                this._restFactoryService.httpPostService(this.API_CREATE_NEW_SKIN, payload)
                    .pipe(
                        takeUntil(this._unsubscribeAll),
                        finalize(() => {
                            this.spinner.hide("managementSpinner").then();
                            this._changeDetectorRef.detectChanges();
                        }),
                        catchError((err) => {
                            return err;
                        })
                    )
                    .subscribe(
                        (response) => {
                            this.spinner.hide("managementSpinner").then();
                            this.messageFactory.createSuccessMessageBox("Success!", "Skin has been created.", 2000);
                            this.toggleAddSkin();
                            this.searchElements(null);
                        });
            }
        });
    }

    toggleAddSkin(): void {
        this.selectedMapElement = null;
        this.selectedElement = null;
        if (!this.displayAddSkin) {
            this.createForm();
        } else {
            this.newDestinationForm = null;
            this.parentControl.reset();
        }
        this.displayAddSkin = !this.displayAddSkin;
    }

    onInputMaxReach(event: any, maxReach: number = 15): void {
        const inputValue = event.target.value;
        if (inputValue.length >= maxReach) {
            this._snackBar.open(`This field has a limit of ${maxReach} characters. Any text exceeding this limit will be cut off.`, "Close", {
                duration: 5000,
                panelClass: ['bg-card', 'dark:bg-transparent']
            });
        }
    }
}
